var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanguageOutlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.973,
    height: 28.651,
    viewBox: "0 0 31.973 28.651",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#666;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-47 -63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M48,67.291H68.529M58.264,64v3.291m5.7,23.039L70.81,74.971,77.652,90.33M66.069,85.942h9.48M64.63,67.291a33.146,33.146,0,0,1-5.866,11.314,35.512,35.512,0,0,1-8.482,7.337"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M148.08,201.1a70.271,70.271,0,0,1-11.295-11.765A96.939,96.939,0,0,1,128,176",
    transform: "translate(-77.341 -111.385)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageOutlineIcon);
export default __webpack_public_path__ + "static/media/language-outline-icon.dff27007e605d1bb2fa3b611a508c74c.svg";
export { ForwardRef as ReactComponent };